import React, { useState } from 'react'

import Highlight from 'react-highlight'
import 'highlight.js/styles/atom-one-dark.css';

import './APIExamples.scss';
import APIExamplesContent from './api_examples_content.js'

const MenuItems = [
  {"name": "Analysis", "items": [
    "IP Range Search",
    "Hostname Search",
    "Volumes and PCAPs",
    "Payload Analysis",
    "Connections On Port",
    "IPs for Hostname",
    "Hostnames for IPs",
  ]},
  {"name": "Blacklists", "items": [
    "Hostnames",
    "IPs",
  ]},
];

function APIExamples() {
  const [active, setActive] = useState(MenuItems[0]["items"][0]);
  const [language, setLanguage] = useState("python");

  function handleClickMenuItem(item) {
    setActive(item);
  }

  function handleClickLanguage(language) {
    setLanguage(language);
  }

  function LanguageButtonclasses(language_arg) {
    return "button is-small" + (language === language_arg ? " is-active" : "")
  }

  function makeHTTPie(url) {
    return "http \\\n    " + url + " \\\n    HoneyShare-Key:your-honeyshare-key";
  }

  function makeCurl(url) {
    return "curl " + url + "\\?key\\=your-honeyshare-key";
  }

  function makeDescription() {
    return APIExamplesContent[active]["Description"];
  }

  function makeExample() {
    let examples = APIExamplesContent[active]["Examples"];

    switch(language) {
      case "httpie":
        return makeHTTPie(examples["url"]);
      case "curl":
        return makeCurl(examples["url"]);
    }

    return examples[language];
  }

  function makeOutput() {
    return APIExamplesContent[active]["Output"];
  }

  return (
    <div className="container">
      <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
        API Examples
      </h3>
      <div className="container columns">
        <div className="column is-one-third">
          <aside className="menu honey-api-example-menu">
            {MenuItems.map((field, index) => (
              <div key={index}>
                <p className="menu-label">{field["name"]}</p>
                <ul className="menu-list">
                  {field["items"].map((item, index) => {
                      let is_active = item === active ? "honey-is-active" : "";
                      return (
                        <li key={index}><a className={is_active} onClick={() => {handleClickMenuItem(item)}}>
                          {item}
                        </a></li>
                      )
                  })}
                </ul>
              </div>
            ))}
          </aside>
        </div>
        <div className="column is-two-thirds honey-code">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <h5 className="has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common">
                  {makeDescription()}
                </h5>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <div className="buttons has-addons is-right">
                  <button className={LanguageButtonclasses("python")} onClick={() => {handleClickLanguage("python")}}>Python</button>
                  <button className={LanguageButtonclasses("httpie")} onClick={() => {handleClickLanguage("httpie")}}>HTTPie</button>
                  <button className={LanguageButtonclasses("curl")} onClick={() => {handleClickLanguage("curl")}}>Curl</button>
                </div>
              </div>
            </div>
          </div>
          <Highlight className="language-python">
            {makeExample()}
          </Highlight>
          <div className="honey-api-example-spacer"></div>
          <Highlight className="language-json">
            {makeOutput()}
          </Highlight>
        </div>
      </div>
      <div className="container has-text-right honey-text-common honey-api-example-pypi">
        <a target="_blank" rel="noopener noreferrer" href="https://pypi.org/project/honeyshare/">
          Library available in Pypi
        </a>
        &nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://pypi.org/project/honeyshare/">
          <i className="fa-solid fa-arrow-up-right-from-square"></i>
        </a>
      </div>
    </div>
  )
}

export default APIExamples;
